import { ReactNode, useRef } from "react";
import { CSSTransition } from "react-transition-group";
//------------------------------------------
export default function TransitionWidthHeight({
    classNames, 
    In, 
    children, 
    timeout
}:{
    classNames: string, 
    In: boolean, 
    children: ReactNode, 
    timeout: number
}){
    //------------------------------------------
    const nodeRef = useRef(null);
    //------------------------------------------
    return (
            <CSSTransition 
                classNames = {classNames}
                in = {In}
                timeout = {{ 
                    enter: timeout || 300,
                    exit: timeout || 300
                }}
                mountOnEnter
                unmountOnExit
                nodeRef = {nodeRef}
            >
                <div ref = {nodeRef}>{children}</div>
            </CSSTransition>
    )
}